import React, { useEffect, useState } from "react";
import styles from "./ClientComponents.module.scss";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function BatteryPerformanceWidget({ building }) {
  const [batteryDetails, setBatteryDetails] = useState({});
  const [totalDischarge, setTotalDischarge] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(new Date());

  useEffect(() => {
    const getTableData = async () => {
      const response = await axios.get(
        `/batteries/getPerformanceDataClient?buildingId=${building.id}&selectedMonth=${selectedMonth}`
      );

      if (response.status === 200) {
        setBatteryDetails(response.data[0]?.formattedData);
        setTotalDischarge(response.data[0]?.sumOfDischarge);
      }
    };

    getTableData();
  }, [selectedMonth, building]);

  return (
    <div className={styles.LineChartContainer}>
      <div className={styles.LineChartDatePickerContainer}>
        <div className={styles.ChartHeaders}>
          <div>Selected Month:</div>
          <DatePicker
            dateFormat="MM/yyyy"
            selected={selectedMonth}
            onChange={(date) => setSelectedMonth(date)}
            onFocus={(e) => (e.target.readOnly = true)}
            showMonthYearPicker
          />
        </div>
        <div className={styles.ChartHeaders}>
          <div>
            Total Discharge for {moment(selectedMonth).format("MMM YYYY")}:
          </div>
          <h5>{Number(totalDischarge).toFixed(2)}</h5>kWh
        </div>
      </div>
      {batteryDetails?.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={350}
            data={batteryDetails}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 80,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" angle={-45} textAnchor="end" dy={10} />
            <YAxis unit={"kWh"} />

            <Tooltip />
            <Legend
              verticalAlign="top"
              wrapperStyle={{ paddingTop: 10, paddingBottom: 10 }}
            />
            <Line
              type="monotone"
              dataKey="charge"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
              unit={"kWh"}
            />
            <Line
              type="monotone"
              dataKey="discharge"
              stroke="#82ca9d"
              unit={"kWh"}
            />
          </LineChart>
        </ResponsiveContainer>
      ) : null}
    </div>
  );
}

export default BatteryPerformanceWidget;
